import { Box, Typography } from "@mui/material";
import { Pipeline, Task, TaskStatusType } from "../../models/tasks";
import { useNavigate } from "react-router";
import "./TaskItem.scss";
import ImageIcon from "@mui/icons-material/Image";

const lungs = require("../../images/lungs.png");
const tumor = require("../../images/tumor.png");

interface TaskItemInterface {
  task: Task;
  selected: boolean;
  open: boolean;
  reroute?: string;
}

export const TaskItem = ({ task, selected, open, reroute = "/tasks?id=" }: TaskItemInterface) => {
  const navigate = useNavigate();
  const lastStatus =
    task.statuses && task.statuses.length > 0 ? task.statuses[task.statuses.length - 1].status : TaskStatusType.WAITING;
  const lastStatusClassName =
    lastStatus === TaskStatusType.COMPLETED
      ? "completed"
      : lastStatus === TaskStatusType.TERMINATED
        ? "failed"
        : lastStatus === TaskStatusType.WAITING
          ? "waiting"
          : "pending";

  let taskClass = "taskItem";
  if (selected) taskClass += " taskItem-selected";
  if (!open) taskClass += " taskItem-closed";

  return (
    <div key={task.id} className={taskClass} onClick={() => navigate(reroute + task.id)}>
      <div className="taskItem-left">
        <div className="taskItem-left-icon" style={{}}>
          <img src={task.pipeline === Pipeline.LUNGS_REPORT ? lungs : tumor} alt="Task Icon" />
        </div>
        {open && (
          <Box className="taskItem-info">
            <Typography variant={"h4"}>{task.name}</Typography>
            <Typography variant={"subtitle2"} className="taskItem-info-date">
              {new Date(task.createdAt).toLocaleString()}
            </Typography>
          </Box>
        )}
      </div>
      {open && (
        <Box className={"taskItem-info"}>
          {/*<Typography variant={"body2"}>{new Date(task.createdAt).toLocaleString()}</Typography>*/}
          <Box className={"taskItem-info-status taskItem-info-status-" + lastStatusClassName}>
            <Typography variant={"caption"}>{lastStatus}</Typography>
          </Box>
        </Box>
      )}
    </div>
  );
};
